module.exports = __webpack_public_path__ + "static/media/child.6c9cb6a8.glb";